<script>
import GroupOrderBlock from '@/components/organism/block/GroupOrderBlock'
import Box from '@/components/atoms/Box'
import ComplementaryPaymentBlock from '@/components/organism/checkout/ComplementaryPaymentBlock'
import ExpenseCodeBlock from '@/components/organism/checkout/ExpenseCodeBlock'
import PaymentBlocks from '@/components/organism/checkout/PaymentBlocks.vue'
export default {
    name: 'CanteenPayment',

    components: {
        PaymentBlocks,
        ExpenseCodeBlock,
        ComplementaryPaymentBlock,
        Box,
        GroupOrderBlock,
    },

    props: {
        stripe: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        cart() {
            return this.$cart || {}
        },
        calculation() {
            return this.$cart.calculation || {}
        },
        canteen() {
            return this.cart.calculation.cloudcanteen || {}
        },
        nullBudgetCanteen() {
            return this.canteen.budget === null
        },
        currency() {
            return this.$store.getters['active/currency']
        },
        showPaymentExtension() {
            return this.priceSumUser > 0
        },
        showExpenseCodes() {
            return Boolean(
                (this.calculation.cloudcanteen?.expense_code_required &&
                    (this.calculation.cloudcanteen?.expense_code_list ||
                        !this.calculation?.cloudcanteen.expense_code_only_from_list)) ||
                    (this.isStripe && !this.calculation.selected_expense_rule)
            )
        },
        priceSum() {
            return this.cart.calculated ? this.calculation.price_sum : 0
        },
        priceSumUser() {
            return this.cart.calculated ? this.calculation.price_sum_user : 0
        },
        remainingSum() {
            return this.canteen.budget - this.priceSum
        },
        isStripe() {
            return this.cart.payment_method === this.$cardPayment
        },
    },
}
</script>

<template lang="pug">
.canteen-payment
    .d-flex.align-items-center(v-if="canteen")
        h3.my-0.mr-2.text-break {{ canteen.name }}
        template(v-if="!nullBudgetCanteen")
            icon.text-99.mr-2.ml-auto(icon="fa-solid fa-wallet")
            span {{ canteen.budget | toCurrency(currency.locale, currency.currency_code) }}
    group-order-block(v-if="cart.canCanteenGroupOrder && !nullBudgetCanteen" id="group_info" checkout)
    template(v-if="nullBudgetCanteen")
        payment-blocks(:stripe="stripe")
    box(:value="showPaymentExtension" slim v-else)
        complementary-payment-block.mt-4(:stripe="stripe" id="complementary_payment_method" :remaining-sum="remainingSum")
    box(:value="showExpenseCodes" slim )
        expense-code-block.mt-4(canteen id="expense_code" :active="showExpenseCodes")
</template>
